import { render, staticRenderFns } from "./giftEditTabInformation.vue?vue&type=template&id=ffac3ba6&scoped=true&"
import script from "./giftEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./giftEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./giftEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffac3ba6",
  null
  
)

export default component.exports